import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/modals/');

export default function ListDModal() {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.ListD1} modal-listD1`}>
            <div className="listD1Box">
                <div className="title-box">
                    <div className="title1">{t('presale.product.modals.listD1_ms1')}</div>
                    <div className="title2">{t('presale.product.modals.listD1_ms2')}</div>
                    <div className="title3">
                        {t.rich('presale.product.modals.listD1_ms3', {
                            line1: (child: any) => <span className="span-font">{child}</span>,
                        })}
                    </div>
                    <div className="title4">
                        <div className="title4-box">
                            <div className="title4-ms1">3600W</div>
                            <div className="title4-ms2">{t('presale.product.modals.listD1_title1')}</div>
                        </div>
                        <div className="title4-box">
                            <div className="title4-ms1">{t('presale.product.modals.listD1_value2')}</div>
                            <div className="title4-ms2">{t('presale.product.modals.listD1_title2')}</div>
                        </div>
                    </div>
                </div>
                <div className="content-box">
                    <div className="content-box_row">
                        <div className="row_img border">
                            <p>{t('presale.product.modals.listD1_ms5')}</p>
                            <EFPic name={['list_modal_row1.webp', 'list_modal_row1.jpg']} className="fullImgs" alt={t('presale.product.modals.listD1_ms1')} />
                        </div>
                        <div className="row_img border">
                            <p>{t('presale.product.modals.listD1_ms4')}</p>
                            <EFPic name={['list_modal_row2.webp', 'list_modal_row2.jpg']} className="fullImgs" alt={t('presale.product.modals.listD1_ms1')} />
                        </div>
                    </div>
                    <div className="content-box_row">
                        <EFPic
                            name={['list_modal_row3.webp', 'list_modal_row3.jpg']}
                            className="fullImgs left-img"
                            alt={t('presale.product.modals.listD1_ms1')}
                        />
                        <div className="video_box border">
                            <EFVideo sources={['/video/mm100m/modal/listD1_1.webm', '/video/mm100/modal/listD1_1.mp4']} className="video" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
